var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:{cursor_pointer: _vm.state},style:(_vm.getStyle),on:{"click":_vm.navigate}},[(_vm.state)?_c('div',{staticClass:"hoverCover"}):_c('div',{staticClass:"disableCover"})])}
var staticRenderFns = []

export { render, staticRenderFns }